import styled from 'styled-components';

export const Badge = styled.div`
  --width: 40cqw;
  position: absolute;
  bottom: calc(50% - (var(--width) / 2));
  right: 0;
  width: var(--width);
  max-width: 100px;
  max-height: 100px;

  /*
   * An inline image sits on the text baseline and reserves room beneath itself for descenders,
   * so the line box runs a few pixels past the bottom of the image. On the PDP that pushed this
   * absolutely positioned badge ~4px below the bottom of the carousel slide and gave the scroll
   * container 3px of vertical overflow (scrollHeight 304 vs clientHeight 301), which let the
   * slides drift vertically during a horizontal swipe on mobile. Only badged products moved.
   * Taking the image out of flow removes the descender space entirely.
   */
  & img {
    display: block;
  }

  
  &:is(.product__images &) {
    bottom: 0;
    
    @media (width >= 58rem) {
      bottom: var(--spacing-large);
      right: var(--spacing-large);
      width: 20cqw;
    }
  }
`;
